import { render, staticRenderFns } from "./customizedPrices.vue?vue&type=template&id=7d845010&"
import script from "./customizedPrices.vue?vue&type=script&lang=js&"
export * from "./customizedPrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports